import React, { useState, useEffect, memo } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import Modal from '../../../common/components/Modal/modal';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { navigate } from 'gatsby';
import styles from './ChangeStatusLead.module.css';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import * as moment from 'moment';
import get from 'lodash/get';
import CommonBtn from '../../LeadProfile/CommonBtn/CommonBtn';
import Audit from '../../../containers/Audit/Audit';
import {
  cityOptions,
  updateStatusOptions,
  updateSubStatusForOpen,
  updateSubStatusForFollowUp,
  updateSubStatusForRejected,
  timeIntalval
} from '../../../containers/RMDashboard/EditLeadOptions';
import { addOrEditLead, getLoanProduct } from '../../../common/constants/api';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';
import _, { min, stubFalse } from 'lodash';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../../common/components/PopUp/PopUp';
import CommonDatePicker from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import Toast from '../../../common/components/Toast/Toast';

const validationSchema = Yup.object().shape({
  updateStatus: Yup.object().shape({
    value: Yup.string().required('Required')
  }),

  updateSubStatus: Yup.object().when('updateStatus', {
    is: updateStatus =>
      updateStatus.value === 'OPEN' ||
      updateStatus.value === 'FOLLOW_UP' ||
      updateStatus.value === 'LEAD_REJECTED',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),

  followTime: Yup.object().when('updateStatus', {
    is: updateStatus => updateStatus.value === 'FOLLOW_UP',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  date: Yup.object().when('updateStatus', {
    is: updateStatus => updateStatus.value === 'FOLLOW_UP',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  month: Yup.object().when('updateStatus', {
    is: updateStatus => updateStatus.value === 'FOLLOW_UP',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  year: Yup.object().when('updateStatus', {
    is: updateStatus => updateStatus.value === 'FOLLOW_UP',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  })
});

function subStatus(status) {
  if (status === 'OPEN') {
    return updateSubStatusForOpen;
  } else if (status === 'FOLLOW_UP' || status == 'FOLLOW UP') {
    return updateSubStatusForFollowUp;
  } else if (status === 'LEAD_REJECTED' || status == 'LEAD REJECTED') {
    return updateSubStatusForRejected;
  } else {
    return [];
  }
}
const ChangeStatusOfLead = ({
  showModal,
  setShowModal,
  rowData,
  onUpdation
}) => {
  const { modalWidth, edit_details_container, formHeight } = styles;

  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        emailId: '',
        city: { value: '', label: 'Select City' },
        loanType: { value: '', label: 'Select Loan Type' },
        loanAmount: '',
        otherCityName: '',
        updateStatus: { value: '', label: 'Update  Status' },
        updateSubStatus: { value: '', label: 'Update Sub Status' },
        followTime: { value: '', label: 'Follow-up Time' },
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: moment().format('MM'),
          label: moment().format('MMMM')
        },
        year: {
          value: moment().format('YYYY'),
          label: moment().format('YYYY')
        },
        initialLoading: true,
        comments: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        setFieldTouched
      }) => {
        const [showCity, setShowCity] = useState(false);

        useEffect(() => {
          if (!values.initialLoading)
            setFieldValue('updateSubStatus', {
              value: '',
              label: 'Update Sub Status'
            });
        }, [values.updateStatus.value]);

        useEffect(() => {
          getLoanProduct()
            .then(res => {
              setProductTypeOptions(res);
            })
            .catch(err => {
              setShow(false);
              setShowModal(false);
            });
        }, []);

        function updateLead() {
          let body = {
            name: {
              firstName: values?.firstName || '',
              middleName: '',
              lastName: values?.lastName || ''
            },
            productId: values?.loanType?.value || '',
            leadStatus: values?.updateStatus?.value,
            subStatus: values?.updateSubStatus?.value,
            loanAmount: values?.loanAmount,
            city:
              values?.city?.value != 'Others'
                ? values?.city.value
                : values?.otherCityName,

            followDateTime: (() => {
              if (values.date?.value) {
                let splitValue = values?.followTime?.value.split(':');

                const hour = parseInt(splitValue[0], 10);
                const minute = parseInt(splitValue[1], 10);
                let date = new Date(
                  values.year.value,
                  parseInt(values.month.value) - 1,
                  values.date.value,
                  hour || 0,
                  minute || 0
                );
                return date;
              }
            })(),
            comment: values?.comments || ''
          };

          if (values?.emailId) {
            body.email = values?.emailId;
          }
          setShowModal(false);
          setType('loading');
          setText('Upadating The Lead Status Please Wait...');
          setShow(true);
          let applicationDetails = {
            leadId: rowData.leadId,
            leadApplicantId: rowData.leadMainApplicantId,
            applicationStatus: rowData.status,
            leadData: rowData
          };
          setApplicantionInfo(applicationDetails);
          addOrEditLead(body, getApplicantionInfo().leadId)
            .then(res => {
              setShowModal(false);
              setShow(false);

              Toast(
                'success',
                'Lead status has been updated successfully',
                '3000',
                'top-center'
              );

              if (typeof onUpdation == 'function') onUpdation(values);
            })
            .catch(error => {
              setShow(false);
              setShowModal(false);
            });
        }
        useEffect(() => {
          setFieldValue('firstName', rowData?.leadName?.firstName);
          setFieldValue('lastName', rowData?.leadName?.lastName);
          setFieldValue('emailId', rowData?.emailId);
          setFieldValue('loanAmount', rowData?.loanAmount);

          for (let i = 0; i <= cityOptions?.length; i++) {
            if (
              cityOptions[i]?.value?.toLowerCase() ==
              rowData?.propertyCity?.toString().toLowerCase()
            ) {
              setFieldValue('city', {
                value: rowData?.propertyCity || '',
                label: rowData?.propertyCity || 'Select City'
              });
              break;
            } else if (rowData?.propertyCity && i == cityOptions?.length - 1) {
              setFieldValue('city', {
                value: 'Others',
                label: 'Others'
              });
              setFieldValue('otherCityName', rowData?.propertyCity);
              setShowCity(true);
            }
          }

          updateStatusOptions.map(each => {
            let value = each?.value?.replace(/_/g, ' ')?.toLowerCase();
            let lead_status = rowData?.status?.toString()?.toLowerCase();
            if (value == lead_status) {
              return setFieldValue('updateStatus', {
                label: each.label,
                value: each.value
              });
            }
          });

          updateSubStatus(rowData);
        }, []);

        useEffect(() => {
          setFieldValue('date', {
            value: moment(rowData?.nextFollowUpOn)?.format('DD'),
            label: moment(rowData?.nextFollowUpOn)?.format('DD')
          });
          setFieldValue('month', {
            value: moment(rowData?.nextFollowUpOn)?.format('MM'),
            label: moment(rowData?.nextFollowUpOn)?.format('MM')
          });
          setFieldValue('year', {
            value: moment(rowData?.nextFollowUpOn)?.format('YYYY'),
            label: moment(rowData?.nextFollowUpOn)?.format('YYYY')
          });
          setFieldValue('year', {
            value: moment(rowData?.nextFollowUpOn)?.format('YYYY'),
            label: moment(rowData?.nextFollowUpOn)?.format('YYYY')
          });
          setFieldValue('followTime', {
            value: moment(rowData?.nextFollowUpOn)?.format('hh : mm'),
            label: moment(rowData?.nextFollowUpOn)?.format('hh : mm')
          });
        }, []);
        const updateSubStatus = rowData => {
          if (
            typeof subStatus(rowData.status?.toString().toUpperCase()) ==
            'object'
          ) {
            subStatus(rowData.status?.toString().toUpperCase()).map(each => {
              let label = each.label.toLowerCase();
              let lead_sub_status = rowData.subStatus?.toString().toLowerCase();
              if (label == lead_sub_status)
                return setFieldValue('updateSubStatus', {
                  label: each.label,
                  value: each.value
                }).then(res => setFieldValue('initialLoading', false));
            });
          }
        };

        useEffect(() => {
          if (productTypeOptions && productTypeOptions.length != 0)
            productTypeOptions.map(each => {
              if (
                each.displayName?.toLowerCase() ==
                rowData?.loanProduct?.toLowerCase()
              ) {
                setFieldValue('loanType', {
                  value: each.id,
                  label: rowData?.loanProduct
                });
              }
            });
        }, [productTypeOptions]);

        return (
          <React.Fragment>
            <PopUp type={type} text={text} setShow={setShow} show={show} />

            <Modal
              show={showModal}
              setShow={setShowModal}
              classStyle={modalWidth}
              title={
                <span className="font-bold font-roboto text-xl text-black-0">
                  Update Status
                </span>
              }
            >
              <hr className="text-grey-whatsAppBg mb-3" />
              <Form
                autoComplete="off"
                onSubmit={handleSubmit}
                className={`pt-2 pb-6 overflow-auto mb-4 ${formHeight}`}
              >
                <div className="w-full">
                  <div
                    className={`${edit_details_container} grid md:grid-cols-2 gap-x-5 gap-y-3  px-0 mb-10 font-normal font-roboto text-sm text-black-500`}
                  >
                    <CommonSelect sort={true}
                      name="updateStatus"
                      value={values.updateStatus}
                      onChange={e => {
                        setFieldValue('updateStatus', e);
                      }}
                      onBlur={() => {
                        setFieldTouched('updateStatus', true, true);
                      }}
                      options={updateStatusOptions}
                      dropdownStyle={{
                        top: '52px',
                        fontSize: '16px'
                      }}
                      stylesContainer={{
                        height: '52px'
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 20px'
                      }}
                      error={
                        touched.updateStatus &&
                        get(errors, 'updateStatus.value', false)
                      }
                      touched={touched.updateStatus}
                    />
                    <CommonSelect sort={true}
                      disabled={
                        values?.updateStatus?.value === 'INTERESTED'
                          ? true
                          : false
                      }
                      name="updateSubStatus"
                      value={values.updateSubStatus}
                      onChange={e => {
                        setFieldValue('updateSubStatus', e);
                      }}
                      onBlur={() => {
                        setFieldTouched('updateSubStatus', true, true);
                      }}
                      options={subStatus(values?.updateStatus.value)}
                      dropdownStyle={{
                        top: '52px',
                        fontSize: '16px'
                      }}
                      stylesContainer={{
                        height: '52px'
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 20px',
                        opacity:
                          values?.updateStatus?.value === 'INTERESTED'
                            ? '0.5'
                            : '1'
                      }}
                      error={
                        touched.updateSubStatus &&
                        get(errors, 'updateSubStatus.value', false)
                      }
                      touched={touched.updateSubStatus}
                    />
                    {values?.updateStatus?.value == 'FOLLOW_UP' && (
                      <div className={`z-10 w-full`}>
                        <div className="lg:flex block">
                          <div className="w-full ">
                            <p className="text-black-600 font-roboto font-normal text-xs pb-2 text-left">
                              Follow-up Date
                            </p>

                            <CommonDatePicker
                              styleHeight={{
                                height: '52px'
                              }}
                              datePickerContainerstyle={{
                                gridTemplateColumns: '41% 27% 30%'
                              }}
                              onChangeMonth={(value, isValidDate) => {
                                setFieldValue('month', value, true);

                                setFieldTouched('month', true, false);
                                if (!isValidDate) {
                                  setFieldValue(
                                    'date',
                                    {
                                      value: '',
                                      label: 'Date'
                                    },
                                    true
                                  );
                                }
                              }}
                              onChangeYear={(value, isValidDate) => {
                                setFieldValue('year', value, true);
                                setFieldTouched('year', true, false);

                                if (!isValidDate) {
                                  setFieldValue(
                                    'date',
                                    {
                                      value: '',
                                      label: 'Date'
                                    },
                                    true
                                  );
                                }
                              }}
                              onChangeDate={value => {
                                setFieldValue('date', value, true);
                                setFieldTouched('date', true, false);
                              }}
                              valueMonth={values.month}
                              valueYear={values.year}
                              valueDate={values.date}
                              errorYear={
                                touched.year && get(errors, 'year.value', false)
                              }
                              touchedYear={touched.year}
                              onBlurYear={() => {
                                setFieldTouched('year', true, true);
                              }}
                              errorMonth={
                                touched.month &&
                                get(errors, 'month.value', false)
                              }
                              touchedMonth={touched.month}
                              onBlurMonth={() => {
                                setFieldTouched('month', true, true);
                              }}
                              // errors.date.value
                              errorDate={
                                touched.date && get(errors, 'date.value', false)
                              }
                              touchedDate={touched.date}
                              onBlurDate={() => {
                                setFieldTouched('date', true, true);
                              }}
                              disablePastDates={true}
                              minYear={moment().format('YYYY')}
                              maxYear={parseInt(moment().format('YYYY')) + 5}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {values?.updateStatus?.value == 'FOLLOW_UP' && (
                      <div className="w-full " style={{ marginTop: '26px' }}>
                        <CommonSelect sort={true}
                          name="followTime"
                          value={values.followTime}
                          onChange={e => {
                            setFieldValue('followTime', e);
                          }}
                          onBlur={() => {
                            setFieldTouched('followTime', true, true);
                          }}
                          options={timeIntalval(15)}
                          dropdownStyle={{
                            top: '52px',
                            fontSize: '16px',
                            zIndex: '1'
                          }}
                          stylesContainer={{
                            height: '52px'
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 20px'
                          }}
                          error={
                            touched.followTime &&
                            get(errors, 'followTime.value', false)
                          }
                          touched={touched.followTime}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-full -mt-4">
                  <p className="text-grey-corduroy font-open-sans-semi-bold leading-10 text-base">
                    Comments
                  </p>
                  <textarea
                    value={values?.comments || ''}
                    onChange={e => setFieldValue('comments', e?.target?.value)}
                    style={{ minHeight: '20px' }}
                    placeholder="Add a comment..."
                    className="w-full border border-navy-200 rounded p-4"
                  ></textarea>
                </div>
                <div>
                  <button
                    disabled={!_.isEmpty(errors)}
                    onClick={() => {
                      updateLead();
                    }}
                    type="submit"
                    className={`submitButton text-16 w-56 h-12 font-medium  font-roboto bg-green-tiber ${styles?.save}`}
                  >
                    Update
                  </button>
                </div>
              </Form>
            </Modal>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default withErrorHandler(ChangeStatusOfLead);
